import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div v-if="url" class="DocLink">
            <a class="DocLink__link" :href="url" target="_blank">
                <i class="DocLink__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g clip-path="url(#clip0_8412_35839)">
                            <path d="M11.9997 0.810181C11.5597 0.810181 11.1997 1.17018 11.1997 1.61018V14.3302L6.97969 10.1102C6.66969 9.80018 6.15969 9.80018 5.84969 10.1102C5.53969 10.4202 5.53969 10.9302 5.84969 11.2402L11.4397 16.8302C11.4397 16.8302 11.4597 16.8402 11.4697 16.8502C11.5397 16.9102 11.6097 16.9602 11.6897 17.0002C11.7897 17.0402 11.8897 17.0602 11.9997 17.0602C12.1097 17.0602 12.2097 17.0402 12.3097 17.0002C12.3897 16.9602 12.4697 16.9102 12.5297 16.8502C12.5397 16.8502 12.5497 16.8402 12.5597 16.8302L18.1497 11.2402C18.4597 10.9302 18.4597 10.4202 18.1497 10.1102C17.8397 9.80018 17.3297 9.80018 17.0197 10.1102L12.7997 14.3302V1.61018C12.7997 1.17018 12.4397 0.810181 11.9997 0.810181Z" fill="#005537"/>
                            <path d="M11.9997 22.8202C17.9597 22.8202 22.8197 17.9702 22.8197 12.0002C22.8197 9.11018 21.6997 6.40018 19.6497 4.35018C19.3397 4.04018 18.8297 4.04018 18.5197 4.35018C18.2097 4.66018 18.2097 5.17018 18.5197 5.48018C20.2597 7.22018 21.2197 9.53018 21.2197 12.0002C21.2197 17.0802 17.0897 21.2202 11.9997 21.2202C6.90969 21.2202 2.77969 17.0902 2.77969 12.0002C2.77969 9.54018 3.73969 7.22018 5.47969 5.48018C5.78969 5.17018 5.78969 4.66018 5.47969 4.35018C5.16969 4.04018 4.65969 4.04018 4.34969 4.35018C2.30969 6.39018 1.17969 9.11018 1.17969 12.0002C1.17969 17.9602 6.02969 22.8202 11.9997 22.8202Z" fill="#005537"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_8412_35839">
                            <rect width="24" height="24" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </i>

                <span class="DocLink__title">{{ title }}</span>
            </a>
        </div>
    `,

    props: {
        title: { type: String, required: true },
        url: { type: String, required: true },
    },
});
